import styles from './FaqInner.module.scss'
import { useState, useRef, useEffect } from 'react'

interface FaqDetail {
  title: string
  text: string | JSX.Element
}

interface FaqInnerProps {
  faq: FaqDetail[]
}

const FaqInner: React.FC<FaqInnerProps> = ({ faq }) => {
  const [openStates, setOpenStates] = useState<boolean[]>([])
  const contentRefs = useRef<(HTMLElement | null)[]>([])

  // Initialize open states when faq items change
  useEffect(() => {
    setOpenStates(new Array(faq.length).fill(false))
  }, [faq.length])

  const toggleFaq = (index: number) => {
    setOpenStates((prev) => {
      const newStates = [...prev]
      newStates[index] = !newStates[index]
      return newStates
    })
  }

  return (
    <ul className={styles.faqList}>
      {faq.map((item, index) => (
        <li key={index} className={styles.faqList__item}>
          <dl className={styles.faqList__item__box}>
            <dt
              className={`${styles.faqList__item__box__Q} ${openStates[index] ? styles.active : ''}`}
              onClick={() => toggleFaq(index)}
            >
              {item.title}
            </dt>
            <dd
              ref={(el) => (contentRefs.current[index] = el)}
              className={`${styles.faqList__item__box__A} ${openStates[index] ? styles.active : ''}`}
              style={{
                height: openStates[index] ? `${contentRefs.current[index]?.scrollHeight}px` : '0px',
              }}
            >
              <div className={styles.faqList__item__box__A__content}>{item.text}</div>
            </dd>
          </dl>
        </li>
      ))}
    </ul>
  )
}

export default FaqInner
